module.exports = window._path;